import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header.tsx';
import Footer from './components/Footer.tsx';
import HomePage from './pages/HomePage.tsx';
import MenuPage from './pages/MenuPage.tsx';
import ReservationPage from './pages/ReservationPage.tsx';
import TakeawayPage from './pages/TakeawayPage.tsx';
import ContactPage from './pages/ContactPage.tsx';
import RestaurantsPage from './pages/RestaurantsPage.tsx';

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

function App() {
  return (
    <Router>
      <AppContainer>
        <Header />
        <MainContent>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/reserveren" element={<ReservationPage />} />
            <Route path="/takeaway" element={<TakeawayPage />} />
            <Route path="/restaurants" element={<RestaurantsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </MainContent>
        <Footer />
      </AppContainer>
    </Router>
  );
}

export default App;
